import { SuperModel, FieldConfig } from './super-model';

export class FileUploadModel extends SuperModel {
	isReadonly: boolean;
	isHidden: boolean;
	fieldType: FieldType;
	fieldColumn: string;
	isRequired: boolean;
	additionalMetaData: MetadataBuilder = {};
	constructor(
		field
	) {
		super(field);
		this.additionalMetaData = field.additionalMetaData;
		if ([null, undefined].includes(this.additionalMetaData)) {
			this.additionalMetaData = {};
		}
		if (!this.additionalMetaData.hasOwnProperty('supportedType')) {
			this.additionalMetaData.supportedType = null;
		}
		if (!this.additionalMetaData.hasOwnProperty('fileSize')) {
			this.additionalMetaData.fileSize = null;
		}
		if (!this.additionalMetaData.hasOwnProperty('showLabel')) {
			this.additionalMetaData.showLabel = true;
		}
		if (!this.additionalMetaData.hasOwnProperty('changeEventEmit')) {
			this.additionalMetaData.changeEventEmit = true;
		}
		if (!this.additionalMetaData.hasOwnProperty('thumbnailWidth')) {
			this.additionalMetaData.thumbnailWidth = 200;
		}
		if (!this.additionalMetaData.hasOwnProperty('thumbnailHeight')) {
			this.additionalMetaData.thumbnailHeight = 100;
		}
		if (!this.additionalMetaData.hasOwnProperty('showThumbnail')) {
			this.additionalMetaData.showThumbnail =true ;
		}

		if (!this.additionalMetaData.hasOwnProperty('dataUrl')) {
			this.additionalMetaData.dataUrl = false;
		}
	}
}

type FieldType = 'fileUpload';

interface MetadataBuilder {
	supportedType?: string | Array<string>;
	drag?: boolean;
	fileSize?: number | string;
	showLabel?: boolean;
	icon?: string;
	fieldConfig?: FieldConfig;
	changeEventEmit?: boolean;
	thumbnail?: string;
	thumbnailMaxSize?: string;
	thumbnailFormat?: string | Array<string>;
	thumbnailWidth?: number;
	thumbnailHeight?: number;
	dataUrl?: boolean;
	showThumbnail?:boolean;
}
